import { render } from "./UserTasks.vue?vue&type=template&id=434b9dbd&scoped=true"
import script from "./UserTasks.vue?vue&type=script&lang=js"
export * from "./UserTasks.vue?vue&type=script&lang=js"

import "./UserTasks.vue?vue&type=style&index=0&id=434b9dbd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-434b9dbd"]])

export default __exports__